<div [loadingOverlay]="isLoading" class="card-body" style="min-height: 700px">
  <div class="row">
    <div class="col-12">
      <app-components-shared-view-local-profile-list [localProfiles]="localProfiles" [customer]="customer">
      </app-components-shared-view-local-profile-list>
    </div>
  </div>
</div>